import styled, { css } from 'styled-components'

interface MaskedWrapperProps {
  active: boolean
  maxHeight?: string | number
}

export const MaskedWrapper = styled.div<MaskedWrapperProps>`
  ${({ active, maxHeight }) =>
    !active &&
    css`
      & > div {
        max-height: ${maxHeight || 210}px;
        -webkit-transition: -webkit-mask-size 0.22s
            cubic-bezier(0.95, 0.05, 0.795, 0.035),
          max-height 0.32s cubic-bezier(0.95, 0.05, 0.795, 0.035);
        -webkit-mask-image: linear-gradient(
          #000 calc(100% - 9rem),
          transparent
        );
        mask-image: linear-gradient(#000 calc(100% - 9rem), transparent);
        -webkit-mask-size: 100% 100%;
        mask-size: 100% 100%;
        overflow: hidden;
      }
    `};

  label {
    display: block;
    cursor: pointer;

    span {
      color: ${props => props.theme.primaryColor};
    }
  }
`
